import { Action } from "@ngrx/store";

export enum PurchaseActionTypes {
  GET_PURCHASE_PRICE_LIST = "[Purchase] Get Purchase Price List",
  GET_PURCHASE_PRICE_LIST_SUCCESS = "[Purchase] Get Purchase Price List Success",
  GET_PURCHASE_PRICE_LIST_FAILURE = "[Purchase] Get Purchase Price List Error",
  CLEAR_PURCHASE_PRICE_LIST = "[Purchase] Clear Purchase Price List",

  GET_PURCHASE_SIZE = "[Purchase] Get Purchase Sizes List",
  GET_PURCHASE_SIZE_SUCCESS = "[Purchase] Get Purchase Sizes List Success",
  GET_PURCHASE_SIZE_FAILURE = "[Purchase] Get Purchase Sizes List Error",

  GET_DRAWING_LAYOUT_DETAIL = "[Purchase] Get Purchase Drawing Layout Detail",
  GET_DRAWING_LAYOUT_DETAIL_SUCCESS = "[Purchase] Get Purchase Drawing Layout Detail Success",
  GET_DRAWING_LAYOUT_DETAIL_FAILURE = "[Purchase] Get Purchase Drawing Layout Detail Failure",

  GET_MATCHED_PRICE_LIST = "[Purchase] Get Matched Purchase Price List",
  GET_MATCHED_PRICE_LIST_SUCCESS = "[Purchase] Get Matched Purchase Price List Success",
  GET_MATCHED_PRICE_LIST_FAILURE = "[Purchase] Get Matched Purchase Price List Error",
  CLEAR_MATCHED_PRICE_LIST = "[Purchase] Clear Matched Purchase Price List",

  CREATE_PURCHASE_LINE_ITEM = "[Purchase] Create Purchase line item",
  CREATE_PURCHASE_LINE_ITEM_SUCCESS = "[Purchase] Create Purchase line item Success",
  CREATE_PURCHASE_LINE_ITEM_FAILURE = "[Purchase] Create Purchase line item Error",
  CLEAR_PURCHASE_LINE_ITEM = "[Purchase] Clear Purchase line items",

  CREATE_PURCHASE_LINE_ITEM_CONFIG = "[Purchase] Create Purchase line item config",
  CREATE_PURCHASE_LINE_ITEM_CONFIG_SUCCESS = "[Purchase] Create Purchase line item config Success",
  CREATE_PURCHASE_LINE_ITEM_CONFIG_FAILURE = "[Purchase] Create Purchase line item config Error",
  CLEAR_PURCHASE_CONFIG = "[Purchase] Clear Purchase line item config",

  GET_FP_PROJECT_CATEGORY = "[FP Purchase] Get FP Project Category List",
  GET_FP_PROJECT_CATEGORY_SUCCESS = "[FP Purchase] Get FP Project Category List Success",
  GET_FP_PROJECT_CATEGORY_FAILURE = "[FP Purchase] Get FP Project Category List Error",
  
  GET_FP_PROJECT_SUB_CATEGORY = "[FP Purchase] Get FP Project Sub Category List",
  GET_FP_PROJECT_SUB_CATEGORY_SUCCESS = "[FP Purchase] Get FP Project Sub Category List Success",
  GET_FP_PROJECT_SUB_CATEGORY_FAILURE = "[FP Purchase] Get FP Project Sub Category List Error",
  
  GET_FP_PROJECT_SIZE = "[FP Purchase] Get FP Project Size List",
  GET_FP_PROJECT_SIZE_SUCCESS = "[FP Purchase] Get FP Project Size List Success",
  GET_FP_PROJECT_SIZE_FAILURE = "[FP Purchase] Get FP Project Size List Error",
  
  GET_FP_PROJECT_EXTRAS = "[FP Purchase] Get FP Project Extras List",
  GET_FP_PROJECT_EXTRAS_SUCCESS = "[FP Purchase] Get FP Project Extras List Success",
  GET_FP_PROJECT_EXTRAS_FAILURE = "[FP Purchase] Get FP Project Extras List Error",
  
  GET_FP_PROJECT_CATEGORY_SIZE = "[FP Purchase] Get FP Project Category Size List",
  GET_FP_PROJECT_CATEGORY_SIZE_SUCCESS = "[FP Purchase] Get FP Project Category Size List Success",
  GET_FP_PROJECT_CATEGORY_SIZE_FAILURE = "[FP Purchase] Get FP Project Category List Error",
  
  GET_FP_PROJECT_LIST = "[FP Purchase] Get FP Project List",
  GET_FP_PROJECT_LIST_SUCCESS = "[FP Purchase] Get FP Project List Success",
  GET_FP_PROJECT_LIST_FAILURE = "[FP Purchase] Get FP Project List Error",
  
  GET_FP_PROJECT_PRICE_LIST = "[FP Purchase] Get FP Project Price List",
  GET_FP_PROJECT_PRICE_LIST_SUCCESS = "[FP Purchase] Get FP Project Price List Success",
  GET_FP_PROJECT_PRICE_LIST_FAILURE = "[FP Purchase] Get FP Project Price List Error",

  UPDATE_PURCHASE_LINE_ITEM = "[Purchase] Update Purchase line item",
  UPDATE_PURCHASE_LINE_ITEM_SUCCESS = "[Purchase] Update Purchase line item Success",
  UPDATE_PURCHASE_LINE_ITEM_FAILURE = "[Purchase] Update Purchase line item Error",
  CLEAR_PURCHASE_LINE_ITEM_UPDATE = "[Purchase] Clear Purchase line item update",
}

export class GetPurchaseList implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_PRICE_LIST;
  constructor(public payload: any) { }
}

export class GetPurchaseListSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_PRICE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetPurchaseListFailure implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_PRICE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearPurchaseList implements Action {
  readonly type = PurchaseActionTypes.CLEAR_PURCHASE_PRICE_LIST;
  constructor() { }
}

export class GetPurchaseSize implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_SIZE;
  constructor() { }
}

export class GetPurchaseSizeSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetPurchaseSizeFailure implements Action {
  readonly type = PurchaseActionTypes.GET_PURCHASE_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class GetDrawingLayoutDetail implements Action {
  readonly type=PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL;
  constructor() { }
}

export class GetDrawingLayoutDetailSuccess implements Action {
  readonly type=PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL_SUCCESS;
  constructor(public payload: any) { }
}

export class GetDrawingLayoutDetailFailure implements Action {
  readonly type=PurchaseActionTypes.GET_DRAWING_LAYOUT_DETAIL_FAILURE;
  constructor(public payload: any) { }
}

export class GetMatchedPurchasePricing implements Action {
  readonly type = PurchaseActionTypes.GET_MATCHED_PRICE_LIST;
  constructor(public payload: any) { }
}

export class GetMatchedPurchasePricingSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_MATCHED_PRICE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetMatchedPurchasePricingFailure implements Action {
  readonly type = PurchaseActionTypes.GET_MATCHED_PRICE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearMatchedPurchasePricing implements Action {
  readonly type = PurchaseActionTypes.CLEAR_MATCHED_PRICE_LIST;
  constructor() { }
}

export class CreatePurchaseLineItem implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM;
  constructor(public payload: any) { }
}

export class CreatePurchaseLineItemSuccess implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_SUCCESS;
  constructor(public payload: any) { }
}

export class CreatePurchaseLineItemFailure implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_FAILURE;
  constructor(public payload: any) { }
}

export class ClearPurchaseLineItem implements Action {
  readonly type = PurchaseActionTypes.CLEAR_PURCHASE_LINE_ITEM;
  constructor() { }
}

export class CreatePurchaseLineItemConfig implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG;
  constructor(public payload: any) { }
}

export class CreatePurchaseLineItemConfigSuccess implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG_SUCCESS;
  constructor(public payload: any) { }
}

export class CreatePurchaseLineItemConfigFailure implements Action {
  readonly type = PurchaseActionTypes.CREATE_PURCHASE_LINE_ITEM_CONFIG_FAILURE;
  constructor(public payload: any) { }
}

export class ClearPurchaseLineItemConfig implements Action {
  readonly type = PurchaseActionTypes.CLEAR_PURCHASE_CONFIG;
  constructor() { }
}

export class GetFpProjectCategory implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY;
  constructor() { }
}

export class GetFpProjectCategorySuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectCategoryFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectSubCategory implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY;
  constructor(public payload: any) { }
}

export class GetFpProjectSubCategorySuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectSubCategoryFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SUB_CATEGORY_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectSize implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE;
  constructor(public payload: any) { }
}

export class GetFpProjectSizeSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectSizeFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectExtras implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_EXTRAS;
  constructor() { }
}

export class GetFpProjectExtrasSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_EXTRAS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectExtrasFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_EXTRAS_FAILURE;
  constructor(public payload: any) { }
}

////

export class GetFpProjectCategorySize implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE;
  constructor() { }
}

export class GetFpProjectCategorySizeSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectCategorySizeFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectPriceList implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE;
  constructor() { }
}

export class GetFpProjectPriceListSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectPriceListFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectList implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE;
  constructor(public payload: any) { }
}

export class GetFpProjectListSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectListFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_SIZE_FAILURE;
  constructor(public payload: any) { }
}

// Floorplanner

export class GetFpCategorySize implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE;
  constructor(public payload: any) { }
}

export class GetFpCategorySizeSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpCategorySizeFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_CATEGORY_SIZE_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectLists implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_LIST;
  constructor(public payload: any) { }
}

export class GetFpProjectListsSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectListsFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class GetFpProjectPriceLists implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST;
  constructor(public payload: any) { }
}

export class GetFpProjectPriceListsSuccess implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST_SUCCESS;
  constructor(public payload: any) { }
}

export class GetFpProjectPriceListsFailure implements Action {
  readonly type = PurchaseActionTypes.GET_FP_PROJECT_PRICE_LIST_FAILURE;
  constructor(public payload: any) { }
}

export class ClearPurchaseUpdate implements Action {
  readonly type = PurchaseActionTypes.CLEAR_PURCHASE_LINE_ITEM_UPDATE;
  constructor() { }
}

export class UpdatePurchaseLineItem implements Action {
  readonly type = PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM;
  constructor(public payload: any, public id: any) { }
}

export class UpdatePurchaseLineItemSuccess implements Action {
  readonly type = PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM_SUCCESS;
  constructor(public payload: any) { }
}

export class UpdatePurchaseLineItemFailure implements Action {
  readonly type = PurchaseActionTypes.UPDATE_PURCHASE_LINE_ITEM_FAILURE;
  constructor(public payload: any) { }
}

export class ClearPurchaseLineItems implements Action {
  readonly type = PurchaseActionTypes.CLEAR_PURCHASE_LINE_ITEM;
  constructor() { }
}

export type PurchaseActions =
  | GetPurchaseList
  | GetPurchaseListSuccess
  | GetPurchaseListFailure
  | ClearPurchaseList
  | GetPurchaseSize
  | GetPurchaseSizeSuccess
  | GetPurchaseSizeFailure
  | GetDrawingLayoutDetail
  | GetDrawingLayoutDetailFailure
  | GetDrawingLayoutDetailSuccess
  | GetMatchedPurchasePricing
  | GetMatchedPurchasePricingSuccess
  | GetMatchedPurchasePricingFailure
  | ClearMatchedPurchasePricing
  | CreatePurchaseLineItem
  | CreatePurchaseLineItemSuccess
  | CreatePurchaseLineItemFailure
  | ClearPurchaseLineItem
  | CreatePurchaseLineItemConfig
  | CreatePurchaseLineItemConfigSuccess
  | CreatePurchaseLineItemConfigFailure
  | ClearPurchaseLineItemConfig
  | GetFpProjectCategory
  | GetFpProjectCategorySuccess
  | GetFpProjectCategoryFailure
  | GetFpProjectSubCategory
  | GetFpProjectSubCategorySuccess
  | GetFpProjectSubCategoryFailure
  | GetFpProjectSize
  | GetFpProjectSizeSuccess
  | GetFpProjectSizeFailure
  | GetFpProjectExtras
  | GetFpProjectExtrasSuccess
  | GetFpProjectExtrasFailure
  | GetFpCategorySize
  | GetFpCategorySizeSuccess
  | GetFpCategorySizeFailure
  | GetFpProjectLists
  | GetFpProjectListsSuccess
  | GetFpProjectListsFailure
  | GetFpProjectPriceLists
  | GetFpProjectPriceListsSuccess
  | GetFpProjectPriceListsFailure
  | ClearPurchaseUpdate
  | UpdatePurchaseLineItem
  | UpdatePurchaseLineItemSuccess
  | UpdatePurchaseLineItemFailure
  | ClearPurchaseLineItems
